import { Box, type BoxProps, Stack, useColorModeValue } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";

type Props = {
  urlParamKey: string;
  urlParamValue: string;
  count?: number;
} & BoxProps;

const TabLink = ({
  children,
  urlParamValue,
  count,
  urlParamKey,
  ...props
}: Props): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isActive = searchParams.get(urlParamKey) === urlParamValue;

  // Color mode values
  const activeColor = useColorModeValue("gray.900", "gray.100");
  const inactiveColor = useColorModeValue("gray.600", "gray.400");
  const countActiveColor = useColorModeValue("blue.500", "blue.300");
  const countInactiveColor = useColorModeValue("gray.600", "gray.400");

  // to={`?${urlParamKey}=${urlParamValue}`}

  const onClick = () => {
    searchParams.set(urlParamKey, urlParamValue);
    setSearchParams(searchParams);
  };

  return (
    <Box w={"fit-content"} cursor="pointer" onClick={onClick}>
      <Box
        fontSize={"16px"}
        fontWeight={isActive ? 500 : 400}
        lineHeight={"1.2"}
        width="100%"
        flexGrow={1}
        flexBasis="50%"
        borderRadius="8px"
        alignItems="center"
        display="inline-flex"
        justifyContent="center"
        color={isActive ? activeColor : inactiveColor}
        position="relative"
        _after={{
          content: "''",
          width: "60%",
          height: "2px",
          backgroundColor: isActive ? "primary.500" : "transparent",
          position: "absolute",
          top: "calc(100% + 5px)",
          left: "0",
        }}
        {...props}
      >
        <Stack
          direction={"row"}
          spacing="1"
          alignItems={"baseline"}
          whiteSpace="nowrap"
        >
          <Box>{children}</Box>
          <Box
            fontSize={"12px"}
            lineHeight="1.2"
            fontWeight={"400"}
            color={isActive ? countActiveColor : countInactiveColor}
          >
            {isActive ? count : ""}
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default TabLink;
